import { PayloadAction } from '@reduxjs/toolkit'
import { SNACKBAR_DISPLAY, SNACKBAR_HIDE, SET_DEFAULT_PAGINATION } from '../constants/types'

type MainStore = {
    snackbar: {
        open: boolean
        message: string | string[]
        severity: string
        duration: number
        loggerMessage: string | null
    }
    pagination: {
        itemsPerPage: number | null
    }
}

type MainStoreAction = {
    open: boolean
    message: string
    severity: string
    duration: number
    itemsPerPage: number | null
    loggerMessage: string | null
}

const initialState: MainStore = {
    snackbar: {
        open: false,
        message: '',
        severity: 'info',
        duration: 5000,
        loggerMessage: '',
    },
    pagination: {
        itemsPerPage: null,
    },
}

const main = (state = initialState, action: PayloadAction<MainStoreAction>) => {
    switch (action.type) {
        case SNACKBAR_DISPLAY:
            return {
                ...state,
                snackbar: {
                    open: true,
                    severity: action.payload.severity,
                    message: action.payload.message,
                    duration: action.payload.duration || 5000,
                    loggerMessage: action.payload.loggerMessage ?? null
                },
            }
        case SNACKBAR_HIDE: {
            return {
                ...state,
                snackbar: {
                    ...state.snackbar,
                    open: false,
                    message: '',
                    severity: 'info',
                    loggerMessage: null,
                },
            }
        }
        case SET_DEFAULT_PAGINATION: {
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    itemsPerPage: action.payload.itemsPerPage,
                },
            }
        }
        default:
            return state
    }
}

export default main
